var map = {
	"./abc.webp": 91815,
	"./atresmedia.webp": 58734,
	"./el-mundo.webp": 10460,
	"./elconfidencial.webp": 93381,
	"./elperiodico.webp": 30494,
	"./europapress.webp": 11602,
	"./la-razon.webp": 98523,
	"./marca.webp": 96983,
	"./moncloa.webp": 37246,
	"./okdiario.webp": 61911,
	"./que.webp": 71274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93683;